import React from "react"
import styled from 'styled-components'
import { Button, Input } from 'reactstrap'
import get from 'lodash/get'
import SearchIcon from "../../static/images/search_icon.svg"
import { FONTS, COLORS } from '../../constants'

export default class Header extends React.Component {
  uploadFile = (e) => {
    const file = e.target.files[0]
    const data = new FormData()
    data.set('csv', file)
    get(this.props, 'import')(data)
    document.getElementById('fileUpload').value = null
  }

  render() {
    return (
      <Wrapper>
        <WrapperButton>
          <SearchField
            placeholder={ 'Search By Name, ID' }
            value={ get(this.props, 'search') }
            onChange={ get(this.props, 'handleSearch') }
            onKeyDown={ get(this.props, 'handleSearch') }
          />
          <WrapperButton>
            { get(this.props, 'export') &&
              <CustomButton
                bg={ COLORS.UPLOAD_COLOR }
                border={ COLORS.UPLOAD_COLOR_BORDER }
                onClick={ get(this.props, 'export') }
              >
                Export
              </CustomButton>
            }
            { get(this.props, 'import') &&
              <CustomButton
                bg={ COLORS.UPLOAD_COLOR }
                border={ COLORS.UPLOAD_COLOR_BORDER }
              >
                  Import
                <ImportInput
                  id='fileUpload'
                  type="file"
                  onChange={ this.uploadFile }
                />
              </CustomButton>
            }
          </WrapperButton>
        </WrapperButton>
        { get(this.props, 'toggleCreate') &&
          <CustomButton
            bg={ COLORS.SECONDARY_RED }
            border={ COLORS.PRIMARY_RED_BORDER }
            onClick={ get(this.props, 'toggleCreate') }
          >+ Create</CustomButton>
        }
      </Wrapper>
    )
  }
}

const WrapperButton = styled.div`
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const ImportInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;   
  cursor: inherit;
  display: hidden;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => { return props.border }};
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`



// WEBPACK FOOTER //
// ./src/components/searchbar/index.js